import React from 'react';
import PropTypes from 'prop-types';

import './ActionsBar.scss';

/*
Constants and helpers
*/

const getElements = ({ children, start, end }) => children
  .slice(start, end)
  .map((child, index) => (
    <div className="actions-bar-child" key={index}>
      {child}
    </div>
  ));

/*
Component

Property 'left' shows how many children should be on the left.
*/

const ActionsBar = (props) => {
  const {
    children,
    left,
  } = props;

  const leftChildren = getElements({
    children,
    start: 0,
    end: left,
  });

  const rightChildren = getElements({
    children,
    start: left,
  });

  return (
    <div className="blu-actions-bar">
      <div className='blu-actions-left'>
        {leftChildren}
      </div>

      <div className='blu-actions-right'>
        {rightChildren}
      </div>
    </div>
  );
};

ActionsBar.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.func,
    PropTypes.arrayOf(PropTypes.func),
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  left: PropTypes.number,
};

ActionsBar.defaultProps = {
  left: 0,
};

export default ActionsBar;
